import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { ActivatedRoute, Router } from '@angular/router';

declare var $:any

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  submitted = false
  foundEmail: any = null
  emailField = ""
  isValidMail = false

  PortalLogin: any

  resetType = ""

  cookieData: any
  isCrisis = false

  showOkBtn = true

  menuEnabled = false

  constructor(
    private util: UtilService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router
    ) { }

  async ngOnInit() {
    this.resetType = this.activatedRoute.snapshot.queryParams['type'];
    // this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"))
    // if(this.cookieData == null){
    //   this.cookieData = {}
    // }

    let config: any = await this.apiService.get("master", "configuration")
    let crisisConfig: any = config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })

    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
      this.isCrisis = true
    }
    else {
      this.isCrisis = false
    }

    let menuList:any = await this.apiService.get("master", "customerPortalMenuSetting")
    let thisMenu: any = this.util.getMenuObj(menuList, "11", this.isCrisis)
    if(!thisMenu.show ){
      this.util.ShowWaiting(false)
      setTimeout(() => {
        this.router.navigate(["mainmenu/index"])
      }, 500);
      return
    }
    else {
      this.menuEnabled = true
    }
  }

  async checkEmail(){
    this.submitted = true
    this.isValidMail = this.validateEmail()
    if(this.isValidMail){
      this.foundEmail = null
      this.util.ShowWaiting(true)

      let req: any = {
        username: this.emailField.trim(),
        resetType: this.resetType,
        url: this.util.baseUrl()
      }
      let res: any = await this.apiService.postCustomApi("User", "Forgot", req);

      if(res.code == "200"){
        this.foundEmail = true
      }
      else if(res.code == "99"){
        this.foundEmail = false
      }
      else if(res.code == "400"){
        this.util.ErrorDialog(res.msg)
      }
      else if(res.code == "208"){
        let thisTs = this
        this.util.ErrorDialog("กรุณารอสักครู่ ท่านได้ทำรายการเกินจำนวนครั้งที่กำหนด")
        $("#btnMainError").off("click");
        $("#btnMainError").click(function () {
          thisTs.router.navigate(["/mainmenu/index"]);
        });
      }
      else{
        this.util.ErrorDialog("เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่")
      }
      
      this.util.ShowWaiting(false)

      // this.PortalLogin = await this.apiService.getCustomAPI("User", "GetUser", "username=" + this.emailField);
      // if (this.PortalLogin != null) {

      //   let Token: any = {
      //     username: this.PortalLogin.username,
      //     usernameidno: this.PortalLogin.usernameidno,
      //     usertype: "",//this.Type == CustomerType.Person ? "1" : "2",
      //     createBy: null//localStorage.getItem("AgentBank_Profile")
      //   };
      //   let Res: any = await this.apiService.postCustomApi("user", "CreateToken", Token);
      //   if (Res != null) {

      //     let req: any = {
      //       dpa_name: this.PortalLogin.username
      //     }
      //     let guidRes: any = await this.apiService.post("crmservice", "logSendEmail", req);

      //     if(guidRes.RESCODE == "0"){
      //       Res = await this.SendEmail(Res.token_id, guidRes.dpa_sendemailid, this.PortalLogin.username);
      //       if(this.util.isSuccessResponse(Res)){
      //         this.util.ShowWaiting(false)
      //         this.foundEmail = true
      //         this.showOkBtn = false
      //       }
      //       else{
      //         this.util.ShowWaiting(false)
      //         this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ส่ง email กรุณาติดต่อเจ้าหน้าที่")
      //       }
      //     }
      //     else{
      //       this.util.ShowWaiting(false)
      //       this.util.ErrorDialog("เกิดข้อผิดพลาดในการ สร้างคำขอ กรุณาติดต่อเจ้าหน้าที่")
      //     }
      //   }
      //   else{
      //     this.util.ShowWaiting(false)
      //     this.util.ErrorDialog("เกิดข้อผิดพลาดในการ สร้างคำขอ กรุณาติดต่อเจ้าหน้าที่")
      //   }

      // }
      // else{
      //   this.foundEmail = false
      //   this.util.ShowWaiting(false)
      // }
    }
  }

  validateEmail() {
    if (this.emailField.trim().length > 0) {
      const matches = this.emailField.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      return matches ? true :  false ;
    } else {
      return false;
    }
  }

  //วิกฤติ ส่ง useridno ปกติ ส่ง mail
  async SendEmail(TokenID: any, logsendmailid: string, emailAddress: string) {
    let MailObj: any = {
      //contactid: this.PortalLogin.customerid,
      dpa_name: this.PortalLogin.firstname + " " + this.PortalLogin.lastname
    };

    let MailContent = ""
    let url = this.util.baseUrl() + "/resetPassword?id=" + TokenID

    if(this.resetType == "username"){
      MailContent = "เรียน คุณ" + this.PortalLogin.firstname + " " + this.PortalLogin.lastname + "<br /><br />" +
      "   ระบบได้รับคำขอรหัสผู้ใช้งาน(" + (this.isCrisis ? this.PortalLogin.usernameidno : this.PortalLogin.username) + " )ของบัญชีผู้ใช้งาน Customer Web Portal ของคุณ <br /><br />" +
      "รหัสผู้ใช้งานของคุณ : " + (this.isCrisis ? this.PortalLogin.usernameidno : this.PortalLogin.username) + " โปรดคลิกลิงค์ด้านล่างเพื่อตั้งรหัสผ่าน <br /><br />" +
      '<a target="_blank" href="' + url + '">'  + url + "</a><br /><br />" +
      "ขอแสดงความนับถือ <br />" +
      "สถาบันคุ้มครองเงินฝาก <br />" +
      "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
      "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
      "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
      "โทร : 02-272-0300";
    }
    else{
      MailContent = "เรียน คุณ" + this.PortalLogin.firstname + " " + this.PortalLogin.lastname + "<br /><br />" +
      "   ระบบได้รับคำขอให้ตั้งรหัสผ่านใหม่ของบัญชีผู้ใช้งาน Customer Web Portal ของคุณ <br />" +
      "รหัสผู้ใช้งานของคุณ : " + (this.isCrisis ? this.PortalLogin.usernameidno : this.PortalLogin.username) + " โปรดคลิกลิงค์ด้านล่างเพื่อตั้งรหัสผ่าน <br /><br />" +
      '<a target="_blank" href="' + url + '">'  + url + "</a><br /><br />" +
      "ขอแสดงความนับถือ <br />" +
      "สถาบันคุ้มครองเงินฝาก <br />" +
      "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
      "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
      "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
      "โทร : 02-272-0300";
    }
    
    MailObj.dpa_emailaddress = emailAddress
    MailObj.logsendmailid = logsendmailid
    MailObj.dpa_description = MailContent;
    MailObj.dpa_callby = 2
    let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
    return Res;
  }
}



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts